import { ApmService } from "@elastic/apm-rum-angular";

const getApmRumEnvKey = (env: string): string => {

  if (env === 'qa') {
    return 'cp_qa_auth'
  }

  if (env === 'stage') {
    return 'cp_stage_auth'
  }

  if (env === 'production') {
    return 'cp_prod_auth';
  }

  return 'cp_qa_auth';
}

const getApmServerUrl = (env: string): string => {
  if (env === 'production') {
    return 'https://ce47e1aff5a34c0889708350b384fc0a.apm.eu-west-1.aws.cloud.es.io';
  }

  return 'https://nonprod.apm.eu-west-1.aws.found.io';
}


export const initApmRumAgent = (env: string, apmService: ApmService) => {
  return apmService.init({
    serviceName: 'OB-UI-AUTH',
    serverUrl: getApmServerUrl(env),
    breakdownMetrics: true,
    environment: getApmRumEnvKey(env)
  });
}
